const Deposit = ({ size }) => (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" widt={size} height={size} viewBox={`0 0 24 24`} >
        <path d="M12.25 5V17" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M7.75 12.5L12.25 17L16.75 12.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M20.5 19.7858H4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
);

export default Deposit;
